<template>
  <div id="stepThree">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
        <!-- <h2>Financial Assistance</h2>
        <br/>
        <p>Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes through a blind jury process. It is not based on nationality or country/location of residence, anyone can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed. Travel assistance, if awarded, will be communicated upon acceptance.</p>
        <b-form-group>
          <b-form-checkbox id="financialAid" v-model="financialAid">
            I would like to apply for financial assistance
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="financialAid" label="We understand that attending SIGGRAPH can be a considerable financial investment. Please share with us why financial assistance would be important for you to participate." label-for="financialAidSummary">
          <div class="row">
            <div class="col col-md-8">
              <b-form-textarea id="financialAidSummary" @input="wordCount('financialAidSummary', 100)" v-model="financialAidSummary" :rows="6" :max-rows="100"/>
              <p :class="financialAidSummaryWordLimitClass">{{ financialAidSummaryWordCount }}</p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Provide a breakdown of your estimated travel expenses in US Dollars in a list format (travel, lodging, food, daily transportation to the conference, etc.)" label-for="financialAidExpenses">
          <div class="row">
            <div class="col col-md-8">
              <b-form-textarea id="financialAidExpenses" v-model="financialAidExpenses" :rows="6" :max-rows="100"/>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Provide an estimate of your total travel expenses in US Dollars (sum of the breakdown you previously provided)" label-for="estimatedTravelCost">
          <b-form-input type="text" v-model="estimatedTravelCost" id="estimatedTravelCost"></b-form-input>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Primary Mode of Transportation to the Conference's City" label-for="primaryTransport">
          <b-form-select id="primaryTransport" v-model="primaryTransport" :options="primaryTransportList" class="mb-3"/>
        </b-form-group>
        <b-form-group v-if="financialAidAndFlying" label="If Flying, 3-letter Code for Nearest Airport" label-for="airportCode">
          <div class="row">
            <div class="col col-md-2">
              <b-form-input type="text" v-model="airportCode" id="airportCode"></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid">
          <b-form-checkbox id="fundedTravel" v-model="fundedTravel">
            Funding for my travel will be fully or partially covered by outside sources (such as university funding, etc.).
          </b-form-checkbox>
        </b-form-group>
        <br/> -->
      <h2>Become a Team Leader</h2>
      <p v-if="pastTLAppDeadline">The deadline for Team Leader applications has passed</p>
      <div v-else>
        <p>Only SIGGRAPH Student Volunteers with at least 1 year of prior SV experience are eligible for Team Leader positions. Team Leaders (TLs) are Student Volunteers (SVs) selected to serve as liaisons to Venue and Program Chairs across the different areas of the conference.</p>
        <p>TLs have more responsibility and a more demanding workload than a regular SV. TLs serve in a supervisory role as they help train SVs to perform different duties, and resolve more complex attendee, contributor and volunteer questions and issues. TLs also volunteer approximately 60 hours either in pre-conference shifts or during the SIGGRAPH  week in addition to several pre-conference training sessions.</p>
        <p>Please keep in mind the TL application process is very competitive. TL applicants not selected for the role will still be considered for a position as SV.</p>
      </div>
      <b-form-group>
        <b-form-checkbox id="teamLeader" v-model="teamLeader">
          I would like to apply for a Team Leader position
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="teamLeader" label="Being a team leader is a significant responsibility that not only involves working closely with the SVSC and other program chairs, but also fostering a positive, collaborative and encouraging environment for incoming SVs. What inspires you to step up and lead others, and what excites you about taking on this role within SIGGRAPH? " label-for="teamLeaderEssay1">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="teamLeaderEssay1" @input="wordCount('teamLeaderEssay1', 300)" v-model="teamLeaderEssay1" :rows="6" :max-rows="100"/>
            <p :class="teamLeaderEssay1WordLimitClass">{{ teamLeaderEssay1WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <b-form-group v-if="teamLeader" label="How have your past experiences equipped you for this role? What skills have you honed—such as communication, problem-solving, or time management—that make you a strong fit for this position? Additionally, please share any leadership or mentorship experiences you’ve had, whether within SIGGRAPH or in other contexts, and how these have influenced your approach to supporting and guiding others." label-for="teamLeaderEssay2">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="teamLeaderEssay2" @input="wordCount('teamLeaderEssay2', 300)" v-model="teamLeaderEssay2" :rows="6" :max-rows="100"/>
            <p :class="teamLeaderEssay2WordLimitClass">{{ teamLeaderEssay2WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h2>Additional Comments</h2>
      <b-form-group label="We look forward to reviewing your application! Is there anything else you would like to share?" label-for="otherComments">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="otherComments" @input="wordCount('otherComments', 100)" v-model="otherComments" :rows="6" :max-rows="100"/>
            <p :class="otherCommentsWordLimitClass">{{ otherCommentsWordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <b-form-group>
        <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep"><div>Previous Step</div></button>
        <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep"><div>Save and Continue</div></button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import router from '@/router'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepThree',
  data () {
    return {
      teamLeaderEssay1WordCount: '300 words remaining',
      teamLeaderEssay1WordLimitClass: 'under-limit',
      teamLeaderEssay2WordCount: '300 words remaining',
      teamLeaderEssay2WordLimitClass: 'under-limit',
      otherCommentsWordCount: '300 words remaining',
      otherCommentsWordLimitClass: 'under-limit',
      disabled: false
    }
  },
  computed: {
    ...generateVuexSetters([
      'teamLeaderEssay1',
      'teamLeaderEssay2',
      'otherComments'
    ]),
    teamLeader: {
      get () {
        return this.$store.state.application.teamLeader
      },
      set (value) {
        this.$store.commit('application/updateTeamLeader', value)
      }
    },
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapGetters(['pastTLAppDeadline'])
  },
  methods: {
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 4)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepFour' })
          window.scrollTo(0, 0)
          this.disabled = true
        }).catch(err => {
          console.log(err.message)
          this.disabled = true
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 2)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepTwo' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 3) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('teamLeaderEssay1', 300)
    this.wordCount('teamLeaderEssay2', 300)
    this.wordCount('otherComments', 100)
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/application/StepThree.vue